"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _core = require("@popperjs/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./Popover.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function Popover(_ref) {
  var placement = _ref.placement,
    children = _ref.children,
    disabled = _ref.disabled,
    icon = _ref.icon;
  var trigger = (0, _react.useRef)();
  var popup = (0, _react.useRef)();
  var arrow = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    show = _useState4[0],
    setShow = _useState4[1];
  var _useState5 = (0, _react.useState)({
      placement: placement
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    params = _useState6[0],
    setParams = _useState6[1];
  var handleDimmerClick = (0, _react.useCallback)(function () {
    setShow(false);
    setTimeout(function () {
      setVisible(false);
    }, 100);
  }, []);
  var handleContentClick = (0, _react.useCallback)(function (e) {
    e.stopPropagation();
  }, []);
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    if (e.key === 'Escape') {
      handleDimmerClick();
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (arrow.current && trigger.current && popup.current) {
      document.addEventListener('keydown', handleKeyDown);
      var instance = (0, _core.createPopper)(trigger.current, popup.current, {
        placement: placement,
        modifiers: [{
          name: 'offset',
          options: {
            offset: [10, 20]
          }
        }, {
          name: 'arrow',
          options: {
            element: arrow.current,
            padding: 25
          }
        }, {
          name: 'computeStyles',
          options: {
            gpuAcceleration: false // true by default
          }
        }],
        strategy: 'fixed',
        onFirstUpdate: function onFirstUpdate(state) {
          setParams(state);
          setTimeout(function () {
            setShow(true);
          }, 100);
        }
      });
      return function () {
        if (instance) {
          instance.destroy();
        }
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
    return function () {};
  }, [visible, handleKeyDown, placement]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-inline-block dropdown-container"
  }, !icon ? /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-outline-primary btn-rounded",
    type: "button",
    ref: trigger,
    onClick: function onClick() {
      if (!disabled) {
        setVisible(!visible);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, "+")) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon",
    ref: trigger,
    onClick: function onClick() {
      if (!disabled) {
        setVisible(!visible);
      }
    }
  }, icon), visible && /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-layer",
    tabIndex: "0",
    onClick: handleDimmerClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: handleContentClick,
    ref: popup,
    className: "my-dropdown bs-tooltip-".concat(params.placement, " ").concat(show && 'show')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "arrow",
    ref: arrow
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-dropdown-inner"
  }, children))), document.getElementById('root')));
}
Popover.propTypes = {
  placement: _propTypes["default"].string,
  disabled: _propTypes["default"].bool
};
Popover.defaultProps = {
  placement: 'auto',
  disabled: false
};
var _default = exports["default"] = Popover;